<template>
  <div>
    <!-- <g-dialog></g-dialog> -->
    <g-model></g-model>
    <div class="tt">321321</div>
    <div class="aa">
      <div>1</div>
      <div>2</div>
      <p>3</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Test2",
  props: {

  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
.tt {
  @include border-box(100px);
}
.aa {
  @include flex-box(space-around, flex-start);
  p {
    color: var(--white);
  }
}
</style>
